import { createFileRoute } from "@tanstack/react-router"

import { CorpusPanel } from "@/pages/CorpusPanel"

export const Route = createFileRoute("/operations/corpus")({
  // `?docId=` is how every other screen reaches a specific document — My Cleanup and My Files both
  // build it (`corpusHref`), and before this the parameter was simply dropped, so both pages'
  // buttons landed on an unfiltered library. Declared here so the router validates it rather than
  // stripping it.
  validateSearch: (search: Record<string, unknown>): { readonly docId?: string } => ({
    docId: typeof search.docId === "string" && search.docId !== "" ? search.docId : undefined,
  }),
  component: CorpusPanel,
})
